import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <img 
              src="https://www.akarma.com.tr/upload/akarma/logo.png" 
              alt="akarma Logo" 
              className="h-16 w-auto object-contain mb-4 brightness-0 invert"
            />
            <p className="text-sm leading-relaxed mb-4">
              Türk iş dünyasının ihtiyaçlarını karşılamaya yönelik uluslararası standartlar içeren eğitim, ölçme-değerlendirme ve yönetim geliştirme hizmetleri sunmaktadır.
            </p>
	  
 
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/alfafrekansAkarma" className="hover:text-blue-400 transition-colors">
                <Facebook size={20} />
              </a>
              <a href="https://twitter.com/AlfafrekansCom" target="_blank" className="hover:text-blue-400 transition-colors">
                <Twitter size={20} />
              </a>
              <a href="https://www.linkedin.com/in/banu-gokcul-8161621/" target="_blank" className="hover:text-blue-400 transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="https://www.instagram.com/banugokculofficial/" target="_blank" className="hover:text-blue-400 transition-colors">
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Hızlı Linkler</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/hakkinda" className="hover:text-blue-400 transition-colors text-sm">
                  Hakkında
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="hover:text-blue-400 transition-colors text-sm">
                  Hizmetler
                </Link>
              </li>
              <li>
                <Link to="/kitaplar" className="hover:text-blue-400 transition-colors text-sm">
                  Kitaplar
                </Link>
              </li>
              <li>
                <Link to="/kurumsal-egitimler" className="hover:text-blue-400 transition-colors text-sm">
                  Kurumsal Eğitimler
                </Link>
              </li>
              <li>
                <Link to="/bireysel-egitimler" className="hover:text-blue-400 transition-colors text-sm">
                  Bireysel Eğitimler
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Hizmetlerimiz</h4>
            <ul className="space-y-2">
              <li className="text-sm">Koçluk Seansları</li>
              <li className="text-sm">Kurumsal Eğitimler</li>
              <li className="text-sm">Motivasyon Konuşmaları</li>
              <li className="text-sm">Bireysel Danışmanlık</li>
              <li className="text-sm">NLP Terapisi</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">İletişim</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="mt-1 flex-shrink-0 text-blue-400" />
                <span className="text-sm">
                  Etiler Mahallesi Uçaksavar Sitesi<br />
                  Muharipler Sokak No:9 D:2<br />
                  Etiler / Beşiktaş / İstanbul
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="flex-shrink-0 text-blue-400" />
                <div className="text-sm">
                  <div>+90 212 263 34 84</div>
                  <div>+90 532 113 77 48</div>
                </div>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="flex-shrink-0 text-blue-400" />
                <a href="mailto:banu@akarma.com.tr" className="text-sm hover:text-blue-400 transition-colors">
                  banu@akarma.com.tr
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-center md:text-left">
              &copy; {new Date().getFullYear()} akarma Eğitim ve Danışmanlık Merkezi. Tüm hakları saklıdır.
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <Link to="/kullanim-sartlari" className="hover:text-akarma-blue transition-colors">
                Kullanım Şartları
              </Link>
              <span className="text-gray-600">•</span>
              <Link to="/gizlilik" className="hover:text-akarma-blue transition-colors">
                Gizlilik
              </Link>
              <span className="text-gray-600">•</span>
              <Link to="/site-haritasi" className="hover:text-akarma-blue transition-colors">
                Site Haritası
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;